import { Employee } from '@app/models/employee/employee.model';
import { getEmployeeStatus } from '@app/modules/employees/functions/get-employee-status';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { TranslateService } from '@ngx-translate/core';

export class StatusColumn extends Column {
    title = 'table.employeesDirectory.status';
    property = 'status';
    sortable = false;
    type: CellDisplay = CellDisplay.string;

    constructor(private readonly translateService: TranslateService) {
        super();
    }

    getDisplayPropertyValue(employee: Employee): string {
        const status = getEmployeeStatus(employee, employee.account);
        if (!status) {
            return '-';
        }

        const translation = this.translateService.instant(status);

        return translation.charAt(0).toUpperCase() + translation.substr(1).toLowerCase();
    }
}
